import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};
export const AdjustmentIcon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <g id="tabler-icon-adjustments" clipPath="url(#clip0_1046_2329)">
          <path
            id="Vector"
            d="M2.83366 3.15482C2.83366 2.71279 3.00925 2.28887 3.32182 1.97631C3.63438 1.66375 4.0583 1.48815 4.50033 1.48815C4.94235 1.48815 5.36628 1.66375 5.67884 1.97631C5.9914 2.28887 6.16699 2.71279 6.16699 3.15482M2.83366 3.15482C2.83366 3.59685 3.00925 4.02077 3.32182 4.33333C3.63438 4.64589 4.0583 4.82149 4.50033 4.82149C4.94235 4.82149 5.36628 4.64589 5.67884 4.33333C5.9914 4.02077 6.16699 3.59685 6.16699 3.15482M2.83366 3.15482L0.33366 3.15482M6.16699 3.15482L13.667 3.15482M8.25033 10.5834C8.25033 10.1414 8.42592 9.71745 8.73848 9.40489C9.05104 9.09233 9.47496 8.91673 9.91699 8.91673C10.359 8.91673 10.7829 9.09233 11.0955 9.40489C11.4081 9.71745 11.5837 10.1414 11.5837 10.5834M8.25033 10.5834C8.25033 11.0254 8.42592 11.4493 8.73848 11.7619C9.05104 12.0745 9.47496 12.2501 9.91699 12.2501C10.359 12.2501 10.7829 12.0745 11.0955 11.7619C11.4081 11.4493 11.5837 11.0254 11.5837 10.5834M8.25033 10.5834L0.33366 10.5834M11.5837 10.5834L13.667 10.5834"
            stroke="#676979"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1046_2329">
            <rect
              width="13.3333"
              height="13.3333"
              fill="white"
              transform="translate(13.667 0.166748) rotate(90)"
            />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
